import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=1203b30a&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=1203b30a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1203b30a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1203b30a')) {
      api.createRecord('1203b30a', component.options)
    } else {
      api.reload('1203b30a', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=1203b30a&scoped=true&", function () {
      api.rerender('1203b30a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/Dashboard.vue"
export default component.exports